module.exports = __webpack_public_path__ + "static/img/vip-fei-2.9f4cba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-fei-2.png
// module id = xjLv
// module chunks = 1